import React, { FC } from 'react';

import Link from '../Link';
import Group from './Group';
import './styles.scss';

export const socialIcons = {
  facebook: 'bc-i-facebook',
  instagram: 'bc-i-instagram',
  linkedin: 'bc-i-linkedin',
  youtube: 'bc-i-Subtract',
  x: 'bc-i-twitter',
};

export type SocialIconKey = keyof typeof socialIcons;

export interface ShareIconProps {
  name: keyof typeof socialIcons;
  link?: string;
}

const ShareIcon: FC<ShareIconProps> = ({ name, link = '' }) => {
  return (
    <Link target="_blank" href={link} className="ourAddressWeb">
      <i className={`addressSocialIcon ${socialIcons[name]}`} />
    </Link>
  );
};

export default Object.assign(ShareIcon, { Group });
